import React, { useState } from 'react';
import StudentCard from '../StudentCard/StudentCard';
import styles from './StudentWelcome.module.css';

function ProfilePreview({ userData, userProfile }) {
  const [isCollapsed, setIsCollapsed] = useState(true);

  if (!userProfile) {
    return (
      <section className={`${styles.profilePreview} ${styles.loading}`}>
        <h2 className={styles.previewTitle}>Your Profile Preview</h2>
        <div className={styles.previewLoading}>
          <div className={styles.loadingText}>Loading your profile...</div>
        </div>
      </section>
    );
  }

  return (
    <section className={styles.profilePreview}>
      <div className={styles.previewHeader}>
        <div
          className={styles.previewToggle}
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          <h2 className={styles.previewTitle}>Your Profile Preview</h2>
          <svg
            className={`${styles.toggleIcon} ${isCollapsed ? styles.collapsed : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
          </svg>
        </div>
        <button
          onClick={() => window.location.href = '/profile'}
          className={styles.editProfileButton}
        >
          Edit Profile
        </button>
      </div>
      
      {isCollapsed && (
        <p className={styles.previewDescription}>
          This is how your profile appears to professors and other users.
        </p>
      )}
      
      <div className={`${styles.previewContent} ${isCollapsed ? styles.collapsed : ''}`}>
        <div className={styles.cardContainer}>
          <div className={styles.cardWrapper}>
            <StudentCard student={userProfile} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProfilePreview;